/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opens_In_External_PlayerInputs */

const en_opens_in_external_player = /** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens in external player`)
};

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const es_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const fr_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const de_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const ja_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const zh_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const ar_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const id_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const it_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const ru_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const pt_opens_in_external_player = en_opens_in_external_player;

/** @type {(inputs: Opens_In_External_PlayerInputs) => LocalizedString} */
const ko_opens_in_external_player = en_opens_in_external_player;

/**
* | output |
* | --- |
* | "Opens in external player" |
*
* @param {Opens_In_External_PlayerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const opens_in_external_player = /** @type {((inputs?: Opens_In_External_PlayerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opens_In_External_PlayerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opens_in_external_player(inputs)
	if (locale === "es") return es_opens_in_external_player(inputs)
	if (locale === "fr") return fr_opens_in_external_player(inputs)
	if (locale === "de") return de_opens_in_external_player(inputs)
	if (locale === "ja") return ja_opens_in_external_player(inputs)
	if (locale === "zh") return zh_opens_in_external_player(inputs)
	if (locale === "ar") return ar_opens_in_external_player(inputs)
	if (locale === "id") return id_opens_in_external_player(inputs)
	if (locale === "it") return it_opens_in_external_player(inputs)
	if (locale === "ru") return ru_opens_in_external_player(inputs)
	if (locale === "pt") return pt_opens_in_external_player(inputs)
	return ko_opens_in_external_player(inputs)
});